<template>
    <div class="fixed top-0 w-full bg-white text-dark dark:bg-dark.bkg dark:text-dark.textOnBkg p-2.5 shadow-light dark:shadow-dark z-20">
        <section class="pl-10 sm:pl-20 pr-10 container mx-auto flex items-center">
            <logo display_moto="true" />
            <div class="hidden sm:block w-full text-right font-light">Administration & Support</div>
            <div v-if="$route.path !== '/admin/login'" @click="logout()" class="ml-36 sm:ml-10 cursor-pointer p-2">
                <font-awesome-icon icon="fas fa-arrow-right-from-bracket" class="w-5 mr-2.5"/>
            </div>
        </section>
    </div>
    <div class="h-16 w-full"></div>
</template>

<script setup>
    import logo from '@/components/logo.vue';
</script>

<script>
    export default {
        methods: {
            logout() {
                this.$cookies.remove('admin_auth_token');
                this.$router.push('/admin/login');
            }
        }
    }
</script>